import splash_icon from "../assets/images/splash-icon.png";

interface LoaderProps {
  text?: string;
  fullScreen?: boolean;
}

const Loader = ({ text = "Loading...", fullScreen = true }: LoaderProps) => {
  return (
    <div
      className={`flex items-center justify-center overflow-hidden bg-[linear-gradient(-45deg,#e0f7ff,#cfe8ff,#f5fbff,#dff4ff)] bg-[length:400%_400%] animate-gradientShift ${
        fullScreen ? "h-screen" : "h-full min-h-[300px]"
      }`}
    >
      <div className="relative flex flex-col items-center justify-center rounded-[30px] bg-white/20 p-8 backdrop-blur-xl shadow-[0_8px_30px_rgba(0,0,0,0.08)]">
        <div className="absolute z-0 h-[280px] w-[280px] rounded-full bg-[radial-gradient(circle,rgba(119,190,240,0.35)_0%,rgba(119,190,240,0.05)_70%,transparent_100%)] animate-glowRing" />

        <img
          src={splash_icon}
          alt="Loading..."
          className="z-10 h-[220px] w-[220px] rounded-[25px] object-contain animate-floatPulse"
        />

        <p className="z-10 mt-4 text-[18px] font-semibold tracking-[1px] text-[#1f3b57] animate-textBlink">
          {text}
        </p>
      </div>
    </div>
  );
};

export default Loader;
